import { getAuth } from "firebase/auth";
import { getAuthCentral } from "../../config/FirebaseConfig";
import { getFirestore, doc, getDoc } from "firebase/firestore";
import { checkDB } from "../../models/DataFunctions.js";
import addLogDocument from "../addLogDocument"; // Assuming you have this function for logging

// Assuming ChampStruct has a method to convert to JSON
class ChampStruct {
  constructor(type, content, bb, pp, ww, hh, label, page) {
    this.type = type;
    this.content = content;
    this.bb = bb;
    this.pp = pp;
    this.ww = ww;
    this.hh = hh;
    this.label = label;
    this.page = page;
  }

  toJson() {
    return {
      type: this.type,
      content: this.content,
      bb: this.bb,
      pp: this.pp,
      ww: this.ww,
      hh: this.hh,
      label: this.label,
      page: this.page,
    };
  }
}

const edit = async (
  champs,
  urlpdf,
  token,
  folder_id,
  docid,
  prefix,
  height,
  width,
  edit_type,
  fileName = null
) => {
  const editrapport_url = prefix + `edit/folder/${folder_id}/rapport`;
  const editrtb_url = prefix + `edit/folder/${folder_id}/rtb`;
  const editdoc_url = prefix + `edit/doc/${docid}`;
  const editxml_url = prefix + `edit/folder/${folder_id}/xml`;

  const url =
    edit_type === "rapport"
      ? editrapport_url
      : edit_type === "rtb"
        ? editrtb_url
        : edit_type === "xml"
          ? editxml_url
          : editdoc_url;
  champs = champs.map((champ) =>
    champ instanceof ChampStruct
      ? champ
      : new ChampStruct(
          champ.type,
          champ.content,
          champ.bb,
          champ.pp,
          champ.ww,
          champ.hh,
          champ.label,
          champ.page
        )
  );
  const fields = champs.map((champ) => champ.toJson());
  const body = {
    pdf: urlpdf,
    fields: fields,
    target_height: height,
    target_width: width,
    filename: fileName,
  };

  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  try {
    let start = new Date();
    // Send POST request using fetch
    const response = await fetch(url, {
      method: "POST",
      headers: headers,
      body: JSON.stringify(body),
    });

    const auth = getAuthCentral();
    const currentUser = auth.currentUser;

    if (!currentUser) {
      console.error("User not logged in");
      return "";
    }

    const db = getFirestore();
    const userRef = doc(db, "user", currentUser.uid);
    const userSnapshot = await getDoc(checkDB(userRef));
    const org_id = userSnapshot.get("org_id");

    const responseJson = await response.json();
    let end = new Date();
    let elapsed = end - start;
    // Log the request and response
    await addLogDocument(
      url,
      prefix,
      userRef, // Log userRef ID
      org_id,
      response.status.toString(),
      "", // folderid
      "", // docid
      JSON.stringify(body), // request body as string
      responseJson.url,
      "POST",
      elapsed
    );

    // Check response
    if (response.ok) {
      return responseJson.url;
    } else {
      console.error(`Failed to send request: ${response.status}`);
      return "";
    }
  } catch (error) {
    console.error(`Exception occurred: ${error.message}`);
    throw new Error("Request failed");
  }
};

export default edit;
